import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { cn } from "../../primitives/utils";

/**
 * The two halves of the purchase ledger: purchase invoices (One's list, opened on Needs a look) and purchase orders
 * still waiting for an invoice. This header heads the purchase orders half and switches to the invoices.
 */
const VIEWS: { label: string; to: string; isCurrent: boolean }[] = [
  {
    label: "Invoices",
    to: paths.objectList({
      objectId: "finance_purchase_ledger.purchase_invoice",
      search: "queue=needs_a_look",
    }),
    isCurrent: false,
  },
  { label: "Purchase orders", to: paths.purchaseOrders(), isCurrent: true },
];

/**
 * Header for the purchase orders still waiting for an invoice, with one switch to the purchase invoices, because a
 * reviewer moves between the two when an invoice and its order do not line up.
 */
export function PurchaseLedgerHeader({
  summary,
}: {
  /** One line of state: how many orders are waiting and how old the oldest is. */
  summary?: string;
}) {
  return (
    <div className="px-6 pt-6 pb-4">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold tracking-tight">
            Purchase orders
          </h1>
          <p className="text-muted-foreground mt-1 max-w-2xl text-sm">
            Open orders nothing has been invoiced against yet. Goods that have
            arrived with no invoice are the ones to chase, and what month-end
            accrues.
          </p>
          {summary && <p className="mt-2 text-sm font-medium">{summary}</p>}
        </div>
        <nav
          aria-label="Purchase ledger"
          className="bg-muted inline-flex shrink-0 rounded-md p-0.5"
        >
          {VIEWS.map((v) => (
            <Link
              key={v.label}
              to={v.to}
              aria-current={v.isCurrent ? "page" : undefined}
              className={cn(
                "rounded px-3 py-1.5 text-sm font-medium transition-colors",
                v.isCurrent
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              {v.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
}
